const GET_SCREENING_WINDOWS = `query GetWindows($schoolId: ID!, $dateStart: String, $dateEnd: String,$defaultEntities: [DefaultEntity]) {
    assignment(entityId: $schoolId, entityType: SCHOOL, filter: {dateFrom: $dateStart, dateTo: $dateEnd, status: [ASSIGNED,IN_PROGRESS,COMPLETE,DONE], entityType: [SCHOOL, DISTRICT],defaultEntities: $defaultEntities}) {
        assignmentId
        assignmentType
        status
        createdAt
        entityId
        entityType
        dateFrom
        dateTo
    }
}
`;

export default GET_SCREENING_WINDOWS